import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { EnvironmentVariableConfig } from '@aot/host-app-widgets-demo';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
} 
declare global {
  interface Window {
    System: any;
    environmentVariableConfig: EnvironmentVariableConfig;
  }
}

window.System = window.System || {};
window.environmentVariableConfig =
  window.environmentVariableConfig || ({} as EnvironmentVariableConfig);
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

